import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CitizenshipAggregationSearchCrumbs } from 'subscription/constants/breadcrumb';
import ActionsList from './actions';
import PersonSearch from 'shell/components/shared/person-search';

const CitizenshipAggregationSearch = (): React.ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={CitizenshipAggregationSearchCrumbs} />
      <PersonSearch
        pathname="/iscrizioni/aire-cittadinanza-aggregazione/acquisto"
        action={ActionsList}
        addedTitle="- Iscrizione AIRE per acquisto cittadinanza - Aggregazione a famiglia"
        isAire
      />
    </Fragment>
  );
};

CitizenshipAggregationSearch.displayName = 'Citizenship Aggregation Search page component';

export default CitizenshipAggregationSearch;
